import React, { ReactNode, SyntheticEvent } from "react";
import { Tab as MuiTab, Tabs as MuiTabs } from "@mui/material";

export type TabItem<T> = {
  title: string;
  path: T;
  hide?: boolean;
};

export interface TabsProps<T> {
  tabs: TabItem<T>[];
  activeTab: T;
  onChange(event: SyntheticEvent, value: T): void;
  variant?: "default" | "contained";
}

const Tabs = <T,>({
  tabs,
  activeTab,
  onChange,
  variant,
}: TabsProps<T>): ReactNode => (
  <MuiTabs
    value={activeTab}
    onChange={onChange}
    TabIndicatorProps={variant === "contained" ? { style: { display: "none" } } : {}}
    sx={{
      ...(variant === "contained" && {
        "& .MuiTab-root": {
          border: ({ palette }) => `1px solid ${palette.divider}`,
          borderRadius: ({ shape }) => shape.borderRadius,
        },
        "& .MuiTab-root.Mui-selected": {
          backgroundColor: ({ palette }) => palette.custom.purple[50],
          color: ({ palette }) => palette.custom.purple[400],
          border: ({ palette }) => `1px solid ${palette.custom.purple[400]}`,
        },
        "& .MuiTabs-flexContainer": {
          gap: ({ spacing }) => spacing(1),
        },
      }),
    }}
  >
    {tabs
      .filter((tab) => !tab.hide)
      .map((tab) => (
        <MuiTab
          label={tab.title}
          value={tab.path}
          key={tab.path as string}
          disableRipple
        />
      ))}
  </MuiTabs>
);

export default Tabs;
